export const SUGGESTIONS = ['movies', 'dogs', 'how to learn english']
